export class PaymentRequestModel {
    public id!: number;
    public uId!: number;
    public status!: number;
    public statusDetail!: any;
    public userName!: string;
    public createdBy!: any;
    public createdDate!: string;
    public totalAmount!: number;
    public totalPayment!: number;
    public totalOrder!: number;
    public feeShip!: number;
    public receiverPhone!: string;
    public receiverCommune!: number;
    public receiverDistrict!: number;
    public receiverProvince!: number;
    public receiverAddress!: string;
    public shippingMethod!: number;
    public shippingMethodDetail!: any;
    public note!: string;
    public customerNote!: string;
    public communeName!: string;
    public districtName!: string;
    public provinceName!: string;
};